import { useEffect }              from 'react'
import { _bootstrap }             from 'state/store.bootstrap'
import { _project }               from 'state/store.projects'
import { active_project, currentSeason }         from 'state/store.global'
import { useFetch }               from 'hooks/fetch/useFetch'
import { useGet, setFocus, getFocus }       from 'state/jotai'
import { array }                  from 'utilities/utility.misc'
import { preloadImage }           from 'utilities/utility.images'
import { ISO_FRAMES, SEASON_ISO_CONFIG } from 'api/api'
import eachOfLimit                from 'async/eachOfLimit'
import { _seasons_isometry } from 'state/store.season'
import { getIsoData } from 'state/jotai.isometryDataHooks'

export const PreloadSeasons_Frames = () => {

  const { pin, pid } = useGet(active_project)
  
  const type   = useGet(_bootstrap).type
  const cache  = useGet(_seasons_isometry).status
  const poly   = type === 'poly'
  const file   = poly ? 'main/Poly/PolyPreloadFrames.jsx' : ''
  const url    = pid ? SEASON_ISO_CONFIG : null
  const config = useFetch({ url:type?url:null, file }).D
  const season  = getFocus(_seasons_isometry, 'season_type')
  const status  = getIsoData("status");

  const activeIsometryFrame   = getIsoData("activeframe");
  
  const setFrames  = setFocus(_seasons_isometry, 'frames')
  const setPercent = setFocus(_seasons_isometry, 'percent')
  const setStatus  = setFocus(_seasons_isometry, 'status')
  const setConfig  = setFocus(_seasons_isometry, 'config')


 
  useEffect(()=>{
    const seasonType = season?.[pin]?.[pid]?.[activeIsometryFrame]?.type
   
    if (status === 'DONE' && config && activeIsometryFrame && seasonType && !['FETCHING','DONE'].includes(cache?.[pin]?.[pid]?.[activeIsometryFrame]?.[seasonType]) ) {
        const x = config[pin]
      
        const img_snapper = x['IMAGE_SNAPFRAMES']

        const seasons = ['fall', 'summer', 'winter', 'spring']
 
        // Downloading all season frames in render 
        for(let imgSnp = 0; imgSnp < img_snapper.length; imgSnp++) {
          const currIsoFrame = img_snapper[imgSnp]
          let frames = {}
          let PERCENT = '0'
          let seasonLoadPercentage = {}
          let seasonFrameStatus = {}
          let STATUS = 'FETCHING'
          for(let s = 0; s < seasons.length; s++) {
            const s_t = seasons[s]
            const ARR = []
            if(!Object.keys(x.SEASONS?.[currIsoFrame]?.[s_t]).length) continue
            const PATH = x.SEASONS?.[currIsoFrame]?.[s_t].PNG_PATH
            const NUM = Math.ceil(x.SEASONS?.[currIsoFrame]?.[s_t].IMAGE_NUM/30)
            const INI = x.SEASONS?.[currIsoFrame]?.[s_t].FIRST_IMAGE
            const SNP = x.SEASONS?.[currIsoFrame]?.[s_t].IMAGE_SNAPFRAMES
            const EXT = x.FILE_EXT
            let index = 0;
            
            const FNC = x => `${ISO_FRAMES}${PATH}/${x + INI}.${EXT}`
            const COL = array(NUM, FNC, SNP)
            
          setConfig ( a => a?.map((d,i)=> fn(d,i,pin,pid,x)) )
          eachOfLimit(COL, 5, 
            ( val, idx, callback ) => {
              const IMG     = preloadImage(val)
              STATUS  = ( idx !== NUM - 1 ) ? 'FETCHING' : 'DONE'
              PERCENT = ( idx * ( 100 / (NUM - 1) ) ).toFixed() 
            
              for(let i=0; i<30; i++) {
                ARR[index] = { [INI+index]:IMG }
                index++
              }
              IMG.onload = ( ) => callback()


              seasonLoadPercentage[s_t] = PERCENT
              seasonFrameStatus[s_t] = STATUS
              setStatus ( a => a?.map((d,i)=>fn3(d,i,pin,pid,seasonFrameStatus, currIsoFrame  )) )
            },
            () => {
              // console.log( 'Done preloading frames for', pin, pid )
            }
          )
          frames[s_t] = ARR
          }
          
          setPercent( a => a?.map((d,i)=> fn3(d,i,pin,pid,seasonLoadPercentage, currIsoFrame )) )
          setFrames ( a => a?.map((d,i)=> fn3(d,i,pin,pid,frames, currIsoFrame )) )
        }
    }
  },[config, pin, pid, season?.[pin]?.[pid]?.[activeIsometryFrame]?.type, activeIsometryFrame, status])
  return null
}

const fn = (x,y,z,v,w,s,t) => {
  return (y===z) ? s ? { [v] : { [t]: {...x[v][t], [s] : w}} } : { [v] : w} : x
}


// direct updating state for season frames
const fn3 = (x,y,z,v,w,t) => {
  return (y===z) ? { [v] : { ...x[v], [t]: w } }   : x
}
